import React, { useContext } from 'react';
import { useLocation } from 'react-router-dom';
import { ZendeskChatContext } from '@qover/contexts';
// @ts-ignore
import { GlobalLayoutStyles } from '@qover/styles';
import { TopBar, Footer } from '@qover/organisms';
import Config from '@qover/utils/src/Config';
import {
  Breadcrumb,
  LegalMentions,
  Chat,
  ChatWrapper,
  showChat,
} from '@qover/molecules';
import { LayoutContainer } from './layout.styles';
import Step, { Path } from '../../domain/Step';
import { TrFaq } from '../../components/TrFaq';
import { Wizard } from '@qover/hooks/src/useDraft';
import { Draft } from '../../domain/Draft';

type LayoutProps = {
  steps: Array<Step>;
  currentStep?: Path;
  chat: any;
  completionPercentage: number;
  linkTo: (path: string) => string;
  flowStartUrl: string;
  wizard: Wizard<Draft>;
};

function Layout(props: React.PropsWithChildren<LayoutProps>) {
  const location = useLocation();
  const search = new URLSearchParams(location.search);
  const zendeskContext = useContext(ZendeskChatContext);
  const path = props.currentStep?.path;
  const Chatprops = props.chat;

  return (
    <LayoutContainer>
      <GlobalLayoutStyles />
      {zendeskContext.initializeZendesk && (
        <ChatWrapper
          marginBottom="10px"
          marginRight="10px"
          idBedrockElement="footer-container"
        >
          {props.chat ? (
            <Chatprops />
          ) : (
            <Chat
              loadChat={Config.loadChat}
              isBottomNavActive={props.currentStep?.showBottomNav}
            />
          )}
        </ChatWrapper>
      )}
      <TopBar
        completionPercentage={props.completionPercentage}
        flowStartUrl={props.flowStartUrl}
        showChat={showChat}
        showLanguageSelector
        showCountrySelectorModal={search.has('id')}
        updateDraftCountry={props.wizard.updateCountry}
      />
      {props.currentStep?.showBreadcrumb && (
        <Breadcrumb
          steps={props.steps}
          linkTo={props.linkTo}
          currentStep={path as string}
        />
      )}
      {props.children}
      {props.currentStep?.showFaq && (
        <TrFaq filterFaq={!path || path.includes('summary')} />
      )}
      {props.currentStep?.showLegalMentions && <LegalMentions />}
      {props.currentStep?.showFooter && (
        <Footer
          flowStartUrl={props.flowStartUrl}
          showCountrySelectorModal={search.has('id')}
          updateDraftCountry={props.wizard.updateCountry}
        />
      )}
    </LayoutContainer>
  );
}

export default Layout;
